var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEndtrip(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "end_trip",
    "data-name": "end trip",
    transform: "translate(-155 -216)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8192",
    "data-name": "Rectangle 8192",
    width: 32,
    height: 32,
    transform: "translate(155 216)",
    fill: "rgba(255,255,255,0)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "ic_marker_source",
    transform: "translate(163 220)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4748",
    "data-name": "Group 4748",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5911",
    "data-name": "Path 5911",
    d: "M9.625-4.149a2.878,2.878,0,0,0,2.113.873,2.878,2.878,0,0,0,2.113-.873,2.878,2.878,0,0,0,.873-2.113,2.878,2.878,0,0,0-.873-2.113,2.878,2.878,0,0,0-2.113-.873,2.878,2.878,0,0,0-2.113.873,2.878,2.878,0,0,0-.873,2.113A2.878,2.878,0,0,0,9.625-4.149ZM5.794-12.206a8.094,8.094,0,0,1,5.944-2.451,8.094,8.094,0,0,1,5.944,2.451,8.094,8.094,0,0,1,2.451,5.944,11.266,11.266,0,0,1-.873,4,24.659,24.659,0,0,1-2.113,4.225Q15.907,3.935,14.7,5.654T12.64,8.386l-.9.958q-.338-.394-.9-1.042T8.809,5.71A43.42,43.42,0,0,1,6.245,1.935a27.414,27.414,0,0,1-2-4.141,11.4,11.4,0,0,1-.9-4.056A8.094,8.094,0,0,1,5.794-12.206Z",
    transform: "translate(-3.344 14.656)",
    fill: "#df0d17",
    stroke: "rgba(243,243,243,0.16)",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_449",
    "data-name": "Ellipse 449",
    cx: 4.797,
    cy: 4.797,
    r: 4.797,
    transform: "translate(3.598 3.598)",
    fill: "#fff"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEndtrip);
export default __webpack_public_path__ + "static/media/endtrip.dec77c20baaa307e745c6203484681d4.svg";
export { ForwardRef as ReactComponent };